export const SHIFT_TYPE_LABELS = {
  dov: 'DOV',
  weekly_24: 'Weekly 24hr',
  weekly_day: 'Weekly Day',
  weekly_night: 'Weekly Night',
  daily_day: 'Daily Day',
  daily_night: 'Daily Night',
  daily_24: 'Daily 24hr'
};

export const WORK_TYPE_LABELS = {
  yellow_cab: 'Yellow Cab',
  green_boro: 'Green Boro',
  black_car: 'Black Car'
};

export const DRIVE_TYPE_LABELS = {
  standard: 'Standard',
  hybrid: 'Hybrid',
  electric: 'Electric'
};

export const formatDate = (dateStr, includeYear = true) => {
  if (!dateStr) return '';
  const options = {
    month: 'short',
    day: 'numeric'
  };
  if (includeYear) {
    options.year = 'numeric';
  }
  return new Date(dateStr).toLocaleDateString('en-US', options);
};

export const formatPay = (amount, payType) => {
  if (!amount) return null;
  const rateLabel = payType === 'weekly' ? '/wk' : '/day';
  return `$${amount}${rateLabel}`;
};

export const LISTING_TYPE_LABELS = {
  sell: 'Selling',
  buy: 'Buying'
};

export const formatPrice = (amount) => {
  if (!amount && amount !== 0) return null;
  return `$${Number(amount).toLocaleString()}`;
};

// Strip to digits and return the 10-digit portion. Drops a leading '1' from 11-digit inputs
// (US country code). Returns whatever digits were entered, capped at 10 — use for live input.
export const normalizePhoneInput = (value) => {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  return digits.slice(0, 10);
};

// Progressive format for live input or display: "(XXX) XXX-XXXX". Shorter inputs render partial.
export const formatPhone = (value) => {
  const digits = normalizePhoneInput(value);
  if (!digits) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
